import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MyBookingTabShow } from '@common/helpers/enums/servicing.enum';
import { ServicingCommonStoreService } from '@common/services';
import { SERVICING_ROUTES } from '@conf/routes.config';

@Component({
  selector: 'asw-yamato-baggage-guidance-sub-header',
  templateUrl: './yamato-baggage-guidance-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YamatoBaggageGuidanceSubHeaderComponent {
  /** 戻り先URL_予約詳細画面(S01-P030) */
  backUrl = SERVICING_ROUTES.myBooking;

  constructor(private _servicingCommonStoreService: ServicingCommonStoreService) {}

  goBack(): void {
    /** 予約詳細表示タブ=”service”(予約詳細(サービス))を保持 */
    this._servicingCommonStoreService.updateServicingCommon({
      tabShow: MyBookingTabShow.MyBookingTabShowEnum.Service,
    });
  }
}
